import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';
import { subscriptionGuard } from './core/auth/subscription.guard';
import { MainLayoutComponent } from './shared/ui/main-layout/main-layout.component';
import { CHAMADA_ROLES, MANAGE_ER_ROLES, RELATORIO_ROLES, USER_MANAGE_ROLES } from './core/auth/roles';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
    pathMatch: 'full',
  },

  // Rotas de autenticação — sem shell (tela cheia)
  {
    path: '',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  // App shell — rotas autenticadas com sidebar
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'assinatura',
        loadComponent: () =>
          import('./features/subscription/assinatura/assinatura.component').then(
            (m) => m.AssinaturaComponent,
          ),
      },
      {
        path: 'dashboard',
        canActivate: [subscriptionGuard],
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'ers',
        canActivate: [subscriptionGuard, roleGuard([...MANAGE_ER_ROLES])],
        loadChildren: () =>
          import('./features/ers/ers.routes').then((m) => m.ERS_ROUTES),
      },
      {
        path: 'chamadas',
        canActivate: [subscriptionGuard, roleGuard([...CHAMADA_ROLES])],
        loadChildren: () =>
          import('./features/chamadas/chamadas.routes').then((m) => m.CHAMADAS_ROUTES),
      },
      {
        path: 'postos',
        canActivate: [subscriptionGuard],
        loadChildren: () =>
          import('./features/postos/postos.routes').then((m) => m.POSTOS_ROUTES),
      },
      {
        path: 'relatorios',
        canActivate: [subscriptionGuard, roleGuard([...RELATORIO_ROLES])],
        loadChildren: () =>
          import('./features/relatorios/relatorios.routes').then(
            (m) => m.RELATORIOS_ROUTES,
          ),
      },
      { path: 'convites', redirectTo: '/usuarios', pathMatch: 'full' },
      {
        path: 'usuarios',
        canActivate: [subscriptionGuard, roleGuard([...USER_MANAGE_ROLES])],
        loadChildren: () =>
          import('./features/usuarios/usuarios.routes').then(
            (m) => m.USUARIOS_ROUTES,
          ),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
